export default __webpack_public_path__ + "static/media/petgramImg_3.29acff11.webp";